module.exports = __webpack_public_path__ + "img/review.be0d1624.webp";